module.exports = __webpack_public_path__ + "776d58f453c8fe5d6a89e9c31ee223ff.svg";